export default __webpack_public_path__ + "static/media/MTcarpaFull_Frente.8162bcae.webp";